import React from 'react';
import { processSteps } from '../data/process';
export function Process() {
  return <section id="process" className="scroll-mt-20 bg-navy py-20 lg:py-28" aria-labelledby="process-title" data-id="element-211" data-mp="1uddafw38xqm9">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-212" data-mp="1yeowxsqtpvq8">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between" data-id="element-213" data-mp="1yd43y7k5qkuh">
          <h2 id="process-title" className="font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-214" data-mp="23did5sxhw0u3">
            A Clear Path to a Better Pool
          </h2>
          <p className="max-w-sm text-lg text-white/75" data-id="element-215" data-mp="1anjldprx1plq">Five steps from first call to first swim.</p>
        </div>

        <ol className="mt-14 grid lg:grid-cols-5 lg:gap-8" data-id="element-216" data-mp="1fmw9eduix2pw">
          {processSteps.map((step, i) => {
          const last = i === processSteps.length - 1;
          return <li key={step.title} className="relative flex gap-5 pb-10 last:pb-0 lg:block lg:pb-0" data-id="element-217" data-mp="mxyzoz4doe8r" data-mpi={i}>
                {!last && <span className="absolute left-6 top-12 h-[calc(100%-3rem)] w-px bg-accent/30 lg:left-14 lg:right-[-2rem] lg:top-6 lg:h-px lg:w-auto" aria-hidden="true" data-id="element-218" data-mp="19kzf8cx65h7g" />}
                <span className={`relative flex h-12 w-12 shrink-0 items-center justify-center rounded-full font-display text-lg font-extrabold ${last ? 'bg-accent text-navy' : 'border-2 border-accent bg-navy text-accent'}`} data-id="element-219" data-mp="10rcq35ngvc78">
                  {i + 1}
                </span>
                <div className="pt-2 lg:pt-6" data-id="element-220" data-mp="hts2s30coloq">
                  <h3 className="font-display text-lg font-bold text-white" data-id="element-221" data-mp="hul7kyfr1148">{step.title}</h3>
                  <p className="mt-2 text-[15px] leading-relaxed text-white/75" data-id="element-222" data-mp="cwjfxp49bth5">{step.description}</p>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}